import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

export function useX402Config() {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    fetch(`${API}/api/x402/config`).then((r) => r.json()).then(setConfig).catch(() => setConfig({ enabled: false }));
  }, []);
  return config;
}

export const isMainnet = (config) => config?.chain_id === 8453;
